import React, { useEffect, useImperativeHandle, useState } from "react";
import { Col, DatePicker, Form, Input, message, Row, Select, TreeSelect,Checkbox  } from "antd";
import { useModel, useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE } from "../../../utils/constants";
import moment from "moment";
import SupplierService from "../../base/supplier/SupplierService";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";

const dateFormat = 'YYYY-MM-DD';

export default function ({ formRef, actionType }) {
    const history = useHistory();
    const [form] = Form.useForm();
    const { closeNav } = useModelDispatchers("nav");
    const [supplier, setSupplier] = useState({});


    const [{ userInfo }] = useModel("global");
    const { orgId, orgName, userName, } = userInfo;
    const nowTime = moment().format("YYYY-MM-DD HH:mm:ss");

    const [{ invoiceTypeDict, purchaseOrderTypeDict, supplierDict, orgDict, },] = useModel("cmDict");
    const [{
        selectedDocument,
        documentMaterialList,
        detailStatistics,
        formExpand,
        formData
    }, {
        insert, update, loadPo, setDocumentMaterialList, setFormData,
    }] = useModel("purchasePo");

    const { orderStatus = "025001" } = selectedDocument;
    const editable = (
        orderStatus === "025001"
        || orderStatus === "025002"
        || orderStatus === "025003"
    );

    //重新计算优惠总金额和总金额
    const reCompute = () => {
        const discount = form.getFieldValue("discount");
        const favorableAmount = form.getFieldValue("favorableAmount");

        const { poPayableAmount = 0.00, poTotalAmount = 0.00, poTotalNum = 0 } = detailStatistics;

        //应付金额
        const payableAmount = (poPayableAmount * parseFloat(discount) / 100 - parseFloat(favorableAmount)).toFixed(2);
        //优惠总额
        const discountAmount = (poTotalAmount - payableAmount).toFixed(2);
        form.setFieldsValue({
            purchaseNum: poTotalNum,
            payableAmount: !!payableAmount && !isNaN(payableAmount) ? payableAmount : 0.00,
            discountAmount: !!discountAmount && !isNaN(discountAmount) ? discountAmount : 0.00,
        })
        setFormData(form.getFieldsValue());
    }

    useEffect(() => {
        reCompute();
    }, [detailStatistics]);

    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedDocument) {
                form.setFieldsValue({
                    ...selectedDocument,
                    deliveryDate: selectedDocument.deliveryDate ? moment(selectedDocument.deliveryDate, dateFormat) : null
                });
                const { supplierCode, supplierName } = selectedDocument;
                setSupplier({ supplierCode, supplierName })
            }
        } else {
            // console.log(formData)
            form.setFieldsValue({
                ...formData,
                orgId: orgId,
                createUser: userName,
                createTime: nowTime,
            })
        }
    }, [actionType, selectedDocument])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: (setSaveBtnDisabled) => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                form.validateFields().then(formData => {
                    // return console.log(formData)
                    setSaveBtnDisabled(true);
                    const { id } = selectedDocument;
                    const { supplierCode, supplierName } = supplier;
                    const data = {
                        ...formData,
                        details: documentMaterialList,
                        id,
                        supplierCode,
                        supplierName,
                        orgId: orgId,
                        orgName: orgName,
                        createUser: userName,
                        
                    }
                    insert({ showMsg: true, data }).then(retData => {
                        loadPo({ showMsg: false, data: retData }).then(() => {
                            closeNav();
                            goPage(history, "2-3-1");
                        });
                    })
                });
            }

        },
        repair: (setSaveBtnDisabled) => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                form.validateFields().then(formData => {
                    // return console.log(formData)
                    setSaveBtnDisabled(true);
                    const { id } = selectedDocument;
                    const { supplierCode, supplierName } = supplier;
                    const data = {
                        ...formData,
                        details: documentMaterialList,
                        isReplenish:1,
                        id,
                        supplierCode,
                        supplierName,
                        orgId: orgId,
                        orgName: orgName,
                        createUser: userName,
                        
                    }
                    insert({ showMsg: true, data }).then(retData => {
                        loadPo({ showMsg: false, data: retData }).then(() => {
                            closeNav();
                            goPage(history, "2-3-1");
                        });
                    })
                });
            }

        },
        update: async () => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                let formData = await form.validateFields();
                const { id } = selectedDocument;
                const { supplierCode, supplierName,deliveryDate } = supplier;
                const data = { ...formData, details: documentMaterialList, id, supplierCode, supplierName,deliveryDate};
                return await update({ showMsg: true, data })
            }
        },
        reset: () => {
            form.resetFields();
        },
    }));
    const loadSupplier = async (supplierId) => {
        let supplier = await SupplierService.findOne(supplierId);
        if (supplier) {
            setSupplier(supplier);
            const { supplierPerson, supplierPhone, } = supplier;
            form.setFieldsValue({ supplierPerson, supplierPhone });
        }
    }
    const onSupplierChange = async (el) => {
        /*let supplier = await SupplierService.findOne(el["supplierId"]);
        if (supplier) {
            setSupplier(supplier);
            const {supplierPerson, supplierPhone,} = supplier;
            form.setFieldsValue({supplierPerson, supplierPhone});
        }*/
        await loadSupplier(el["supplierId"]);
    };
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{ span: 6 }}
            onValuesChange={(el, els) => {
                // console.log(el);
                const { supplierId } = els;
                // console.log(supplierId);
                reCompute();
                if (el["supplierId"]) {
                    onSupplierChange(el).then(() => setDocumentMaterialList([]));
                }
            }}
            initialValues={{
                discount: 100,
                favorableAmount: 0,
            }}
        >

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="purchaseCode"
                        label="采购单号"
                    >
                        <Input disabled={true} placeholder="采购单号" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierId"
                        label="供应商"
                        rules={[{ required: true, message: '必输字字段', }]}
                        dropdownstyle={{ backgroundColor: '#333' }}
                    >
                        <Select
                            disabled={actionType === CM_ACTION_TYPE.EDIT}
                            showSearch
                            allowClear={true}
                            placeholder="选择供应商"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={supplierDict}
                            rules={[{ required: true, message: '必输字字段', }]}
                            dropdownClassName="dark-select"
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPerson"
                        label="联系人"
                        rules={[{ required: true, message: '必输字字段', }]}
                    >
                        <Input disabled={!editable} placeholder="联系人" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPhone"
                        label="联系电话"
                        rules={[{ required: true, message: '必输字字段', }]}
                    >
                        <Input disabled={!editable} placeholder="联系电话" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        disabled={!editable}
                        name="orderType"
                        label="采购类型"
                        rules={[{ required: true, message: '必输字字段', }]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="订单类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={purchaseOrderTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="deliveryDate"
                        label="到货日期"
                    >
                        <DatePicker disabled={!editable} placeholder="到货日期" style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="purchaseOrderCode"
                        label="采购订单号"
                    >
                        <Input disabled={!editable} placeholder="采购订单号" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="shippingOrderCode"
                        label="发运单号"
                    >
                        <Input disabled={!editable} placeholder="发运单号" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>

                <Col span={6}>
                    <Form.Item
                        name="discount"
                        label="整单折扣"
                        rules={[
                            { required: true, message: '必输字字段', },
                            { pattern: /^(([0-9]\d?)|100)$/g, message: '折扣必须是大于等于0且小于等于100的整数' },
                        ]}
                    >
                        <Input disabled={!editable} placeholder="整单折扣" suffix="%" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="favorableAmount"
                        label="整单优惠"
                    >
                        <Input disabled={true} placeholder="整单优惠" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="discountAmount"
                        label="优惠总额"
                    >
                        <Input disabled={true} placeholder="优惠总额" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="payableAmount"
                        label="应付金额"
                        rules={[
                            { required: true, message: '必输字字段', },
                            () => ({
                                validator: (_, value) => {
                                    return (
                                        (value && parseInt(value) >= 0) ? Promise.resolve() : Promise.reject('不能小于零')
                                    )
                                }
                            }),
                        ]}
                    >
                        <Input disabled={true} placeholder="应付金额" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="purchaseNum"
                        label="采购数量"
                    >
                        <Input disabled={true} placeholder="采购数量" />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        name="invoiceType"
                        label="发票类型"
                    >
                        <Select
                            disabled={!editable}
                            showSearch
                            allowClear={true}
                            placeholder="发票类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={invoiceTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="purchaseDesc"
                        label="备注"
                    >
                        <Input placeholder="备注" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="paidAmount"
                        label="已付金额"
                    >
                        <Input disabled={true} placeholder="已付金额" />
                    </Form.Item>
                </Col>
            </Row>
            {
                (() => {
                    if (actionType === CM_ACTION_TYPE.EDIT && formExpand) {
                        return <>
                            <Row>
                                <Col span={6}>
                                    <Form.Item
                                        name="orgId"
                                        label="组织机构"
                                    >
                                        {/*<Input disabled={true} placeholder="公司"/>*/}
                                        <TreeSelect
                                            disabled={true}
                                            showSearch
                                            allowClear
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder="请选择组织机构"
                                            treeDefaultExpandAll
                                            onChange={() => {
                                            }}
                                            treeData={orgDict}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="createUser"
                                        label="业务员"
                                    >
                                        <Input disabled={true} placeholder="业务员" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="warehouseMan"
                                        label="库管"
                                    >
                                        <Input disabled={true} placeholder="库管" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="financialStaff"
                                        label="财务"
                                    >
                                        <Input disabled={true} placeholder="财务" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Form.Item
                                        name="createUser"
                                        label="制单人"
                                    >
                                        <Input disabled={true} placeholder="制单人" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="createTime"
                                        label="制单时间"
                                    >
                                        <Input disabled={true} placeholder="制单时间" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="updateUser"
                                        label="修改人"
                                    >
                                        <Input disabled={true} placeholder="修改人" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="updateTime"
                                        label="修改时间"
                                    >
                                        <Input disabled={true} placeholder="修改时间" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    }
                })()
            }
            {/* <Row>
                <Col span={6}>
                    <Form.Item
                        name="isReplenish"
                        label={<span style={{color:"red",fontWeight:"bold"}}>补单</span>}
                        valuePropName="checked"
                    >
                        <Checkbox />
                    </Form.Item>
                </Col>
            </Row> */}
        </Form>
    );
}